import PropTypes from 'prop-types';

export const PRODUCT_INFO = {
  id: PropTypes.string,
  languages: PropTypes.arrayOf(PropTypes.string),
  link: PropTypes.string,
  name: PropTypes.string,
  sku: PropTypes.string
};
